<script>
  import { format } from 'svelte-i18n';
  import { Modal, ModalBody, ModalFooter, ModalHeader } from '@sveltestrap/sveltestrap';

  import { Icon } from '@client/components/icon';

  import { ProviderForm } from '../shared';

  export let provider = '';
  export let show = false;
  export let showNextModal = false;

  const onProviderSelect = (pluginProvider) => {
    provider = pluginProvider.value;

    show = false;
    setTimeout(() => (showNextModal = true), 200);

    return provider;
  };

  const onKeyUp = (event) => {
    if (event.key === 'Escape') {
      show = false;
    }
  };
</script>

<Modal bind:isOpen={show} size="xl" fullscreen="lg" scrollable>
  <ModalHeader class="integration-provider-modal-header">
    <button class="close" on:click={() => (show = !show)}>
      <Icon name="x" />
    </button>
    <div>
      <h1>{$format('label.INTEGRATION_PROVIDER_MODAL_NEW_INTEGRATION')}</h1>
      <p>{$format('label.INTEGRATION_PROVIDER_MODAL_CHOOSE_INTEGRATION')}</p>
    </div>
  </ModalHeader>
  <ModalBody class="integration-provider-modal-body">
    <ProviderForm {onProviderSelect} />
  </ModalBody>
  <ModalFooter>
    <div class="integration-note">
      {@html $format('label.NOT_SEEING_INTEGRATION')}
    </div>
  </ModalFooter>
</Modal>

<svelte:window on:keyup={onKeyUp} />

<style lang="scss" src="./provider.scss"></style>
